
import HeaderSection from "./sections/HeaderSection";
import TrainingSchedule from "./sections/TrainingSchedule";
import CredentialsSection from "./sections/CredentialsSection";
import Success from "./Success";
import SamariaSuccessStory from "./SamariaSuccessStory";

const Hero = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      // Account for the fixed header height
      const headerHeight = 80; // Reduced header height for mobile
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <div className="relative min-h-[80vh] flex flex-col items-center justify-center pt-4 sm:pt-8 md:pt-16">
      <div className="container mx-auto px-3 sm:px-6 py-4 sm:py-8 md:py-16 text-center">
        <HeaderSection />
        <CredentialsSection />
        <Success />
        <SamariaSuccessStory />
        <TrainingSchedule onSectionClick={scrollToSection} />
      </div>
    </div>
  );
};

export default Hero;
